import { menusUrl } from './resources.js'
import common from './common.js'
import store from '../store/index.js'

async function getMenusByRestaurant() {
    let restaurantid = store.state.restaurants.currentRestaurant.restaurantId;
    let url = `${menusUrl}/getbyrestaurant/${restaurantid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.menus });
    return data;
}

async function getMenusByRestaurantId(id) {
    let restaurantId = id;
    let url = `${menusUrl}/getactivemenusbyrestaurant/${restaurantId}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response });
    console.log(data);
    return data;
}

async function getMenuDetailById(menuid) {
    let url = `${menusUrl}/getmenudetail/${menuid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response });
    return data;

}

async function createMenu(data) {
    data.restaurantId = store.state.restaurants.currentRestaurant.restaurantId;
    await common.postData(menusUrl, data)
                .catch( err => { console.log(err) } );
}

async function updateMenu(menuid, data) {
    let url = `${menusUrl}/${menuid}`;
    await common.putData(url, data)
                .catch( err => { console.log(err) });
}

async function deleteMenu(menuid) {
    let url = `${menusUrl}/${menuid}`;
    await common.deleteData(url);
}

export default {
    name: 'menusService',
    getMenusByRestaurant,
    getMenusByRestaurantId,
    getMenuDetailById,
    createMenu,
    updateMenu,
    deleteMenu
}